export function getOptionValues(option) {
  return {
    ...(option.engraved_initials !== "" && {
      engraved_initials: option.engraved_initials,
    }),
    ...(option.gift_wrapping && { gift_message: option.gift_message }),
    ...(option.gift_wrapping && { gift_wrapping: option.gift_wrapping }),
  };
}
